// extracted by mini-css-extract-plugin
export var brand = "Brand-module--brand--b7253";
export var descriptions = "Brand-module--descriptions--ac30b";
export var header = "Brand-module--header--1aae4";
export var info = "Brand-module--info--4dcdb";
export var name = "Brand-module--name--936c5";
export var productList = "Brand-module--product-list--2df4b";
export var specialties = "Brand-module--specialties--e38ea";